import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  profileLoading: false,
  childLoading: false,
  totalLoading: null,
  loadingKeywordChartHistory: false,
  pnlByItemDatLoading: false,
  ppcProductCategoryLoading: false,
  groupByPPCLoading: false,
  productVariantLoadig: false,
  ppcDashboardLoading: false,
  salesDashboardLoading: false,
  pnlDashboardLoading: false,
  tagLoading: false,
  keywordTrackingLoading: false,
  productKeywordsDetailLoading: false,
  showKeywordTrackingRelease: false
};

const dataLoadingSlice = createSlice({
  name: 'data_loading',
  initialState,
  reducers: {
    setLoading: (state, action) => ({
      ...state,
      loading: action.payload
    }),
    setProfileLoading: (state, action) => ({
      ...state,
      profileLoading: action.payload
    }),
    setChildLoading: (state, action) => ({
      ...state,
      childLoading: action.payload
    }),
    setLotalLoading: (state, action) => ({
      ...state,
      totalLoading: action.payload
    }),
    setLoadingKeywordChartHistory: (state, action) => ({
      ...state,
      loadingKeywordChartHistory: action.payload
    }),
    setPnlByItemDatLoading: (state, action) => ({
      ...state,
      pnlByItemDatLoading: action.payload
    }),
    setPpcProductCategoryLoading: (state, action) => ({
      ...state,
      ppcProductCategoryLoading: action.payload
    }),
    setGroupByPPCLoading: (state, action) => ({
      ...state,
      groupByPPCLoading: action.payload
    }),
    setProductVariantLoading: (state, action) => ({
      ...state,
      productVariantLoading: action.payload
    }),
    setPpcDashboardLoading: (state, action) => ({
      ...state,
      ppcDashboardLoading: action.payload
    }),
    setSalesDashboardLoading: (state, action) => ({
      ...state,
      salesDashboardLoading: action.payload
    }),
    setPnlDashboardLoading: (state, action) => ({
      ...state,
      pnlDashboardLoading: action.payload
    }),
    setTagLoading: (state, action) => ({
      ...state,
      tagLoading: action.payload
    }),
    setKeywordTrackingLoading: (state, action) => ({
      ...state,
      keywordTrackingLoading: action.payload
    }),
    setProductKeywordsDetailLoading: (state, action) => ({
      ...state,
      productKeywordsDetailLoading: action.payload
    }),
    setShowKeywordTrackingRelease: (state, action) => ({
      ...state,
      showKeywordTrackingRelease: action.payload
    })
  }
});

export const {
  setPnlByItemDatLoading,
  setPpcProductCategoryLoading,
  setGroupByPPCLoading,
  setProductVariantLoading,
  setPpcDashboardLoading,
  setSalesDashboardLoading,
  setPnlDashboardLoading,
  setLoading,
  setProfileLoading,
  setChildLoading,
  setLotalLoading,
  setLoadingKeywordChartHistory,
  setTagLoading,
  setKeywordTrackingLoading,
  setProductKeywordsDetailLoading,
  setShowKeywordTrackingRelease
} = dataLoadingSlice.actions;

export default dataLoadingSlice.reducer;
